import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {ConfirmationPrompt, Features} from '../';
import * as Actions from 'actions';

class FeaturesList extends React.Component {
  constructor(props) {
      super(props);

			this.showDeleteRoleModal = this.showDeleteRoleModal.bind(this);
      this.hideDeleteRoleModal = this.hideDeleteRoleModal.bind(this);
      this.handleConfirmPrompt = this.handleConfirmPrompt.bind(this);
      this.handleToggleAdminRole = this.handleToggleAdminRole.bind(this);
  }

  showDeleteRoleModal() {
  	this.props.showDeleteRoleModal();
  }

  hideDeleteRoleModal() {
  	this.props.hideDeleteRoleModal();
  }

  handleConfirmPrompt() {
  	let {roleManagement} = this.props;
  	let current_role = roleManagement.roles.find(r => r._id === roleManagement.selectedRole)
  	this.props.beginDeleteRole(current_role)
  }

  handleToggleAdminRole() {
  	let {roleManagement} = this.props;
  	let current_role = roleManagement.roles.find(r => r._id === roleManagement.selectedRole)

  	this.props.updateRole({...current_role, is_admin : !current_role.is_admin})
  	this.props.sendSocketEmit({...current_role, is_admin : !current_role.is_admin}, 'edit-role')
  }

  render() {
  	var current_role;
  	if (this.props.roleManagement.selectedRole) {
	  	current_role = this.props.roleManagement.roles.find(r => {
	  		return r._id === this.props.roleManagement.selectedRole;
	  	})
	  }
	  else
	  	current_role = null;

    return (
    	<div className='roles roles-features-list-container'>
    		<div className='col-md-4 col-md-offset-4 col-sm-6 col-sm-offset-3 col-xs-12'>
	    		<ConfirmationPrompt
	    			handleCancelPrompt={this.hideDeleteRoleModal}
	    			handleConfirmPrompt={this.handleConfirmPrompt}
	    			show_condition={this.props.roleManagement.show_delete_role_modal}
	    			title='Delete Role?'
	    			body={'Are you sure youo want to delete ' + (!current_role || !current_role.name ? 'Role?' : current_role.name)}
	    			confirm_button_text='Delete'
	    			cancel_button_text='Cancel'
	    			customClass='delete-role-modal'
	    		/>
    		</div>
    		<div className='row roles-features-list-container-header'>
	    		{(() => {
	    			if (!current_role)
	    				return <h3>Features</h3>;
	    			else
	    				return <h3>{current_role.name + ' - Features'}</h3>
	    		})()}
	    		{(() => {
						if(this.props.roleManagement.selectedRole !== '' && this.props.users.user.is_admin && !this.props.users.proxy_account) {
							return (
								<div className='new-role-admin-toggle-container'>
									<h5 className='pull-left'>Admin Role?</h5>
									<span className='pull-left ml-md switch switch-sm switch-success'>
										<div
											className={`ios-switch ${current_role.is_admin ? 'on' : 'off'}`}
											onClick={this.handleToggleAdminRole}
											>
											<div className='on-background background-fill' />
											<div className='state-background background-fill' />
											<div className='handle' />
										</div>
									</span>
								</div>
								)
						}
					})()}
	    		{(() => {
	    			if(this.props.hasPermission('/Account Management/Roles/Delete/'))
	    				return (
	    					<div
				    			id='delete-roles-button'
				    			className='btn btn-danger pull-right'
				    			disabled={this.props.roleManagement.selectedRole === ''}
				    			onClick={this.showDeleteRoleModal}>
				    			<div className='glyphicon glyphicon-trash'/>
				    			<h6>Delete Role</h6>
				    		</div>
	    				)
	    		})()}
    		</div>
    		<div className='row'>
	    		<Features
	    			featuresContainerClassName='row features-container'
	    			numOfColumns={3}
	    			featuresColumnClassName='col-md-4 col-sm-12'
	    			featureClassName='panel'
	    			featuresHeadingOpenClassName='feature-heading-open'
	    			featuresHeadingClosedClassName='feature-heading-closed'
	    			parentFeatureWrapperClassName='parent-feature-wrapper'
	    			parentFeatureBodyClassName='parent-feature-body'
	    			nestedFeatureWrapperClassName='nested-feature-wrapper'
	    			nestedFeatureBodyClassName='nested-feature-body'
	    		/>
	      </div>
      </div>
    );
  }
}

let mapStateToProps = ({users, roleManagement}) =>  ({
	users,
	roleManagement,
})

export default connect(mapStateToProps, Actions)(FeaturesList)



// WEBPACK FOOTER //
// ./src/browser/components/roleManagement/featureList.js